import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ColorModeService } from './color-mode.service';

@NgModule({
  imports: [CommonModule],
  providers: [ColorModeService],
})
export class ColorModeModule {}
